module.exports = __webpack_public_path__ + "2b9cc5452d752f9117d18bd772fc7c3c.png";